import { Button } from "@/components/ui/button";
import { DotChip } from "@/components/shared/DotChip";
import { useDemoMode } from "@/hooks/useDemoMode";
import { useLanguage } from "@/hooks/useLanguage";

const copy = {
  cs: {
    label: "Ukázková data",
    body: "Smyšlená firma, ať vidíte, jak Zettl páruje platby z Fio s doklady. Nic se neukládá.",
    exit: "Zpět do mé firmy",
  },
  en: {
    label: "Sample data",
    body: "An invented company, so you can see how Zettl matches Fio payments to documents. Nothing is saved.",
    exit: "Back to my company",
  },
} as const;

/**
 * Shown on every app page while sample-data mode is on: says so, and leaves it
 * in one click. Sticky and not dismissable, so the sample is never mistaken
 * for the company's own books.
 */
export function DemoBanner() {
  const { language } = useLanguage();
  const { demo, exit } = useDemoMode();
  if (!demo) return null;
  const t = copy[language];
  return (
    <div
      role="status"
      // Desktop: sticky above the page. Phones scroll the window, where sticky
      // lets go, so there it floats at the bottom (like the sync error card).
      className="z-30 flex flex-wrap items-center gap-x-4 gap-y-2 rounded-lg border border-[hsl(var(--dot-blue)/0.5)] bg-card px-4 py-2.5 max-md:fixed max-md:inset-x-3 max-md:bottom-3 max-md:shadow-lg md:sticky md:top-0 md:mb-6"
    >
      <DotChip color="blue" className="text-[13px] font-medium text-foreground">
        {t.label}
      </DotChip>
      {/* Phones: the sentence takes its own line under the label and the button. */}
      <span className="order-last min-w-0 basis-full text-[13px] text-muted-foreground md:order-none md:flex-1 md:basis-auto">
        {t.body}
      </span>
      <Button
        size="sm"
        variant="outline"
        className="ml-auto md:ml-0"
        onClick={() => void exit(language)}
      >
        {t.exit}
      </Button>
    </div>
  );
}

/** Room under the page on phones, so the floating banner never covers the last row. */
export function DemoBannerSpacer() {
  const { demo } = useDemoMode();
  return demo ? <div aria-hidden="true" className="h-28 md:hidden" /> : null;
}
